import { Pipe, PipeTransform } from '@angular/core';
import { MktEnvironmentService } from '../../core/services/mkt-environment.service';

@Pipe({ 
  name: 'environmentUrl', 
  standalone:false
})
export class EnvironmentUrlPipe implements PipeTransform {
  constructor(private _mktEnvironmentService: MktEnvironmentService) {}
  transform(url: string) {
    const cbolPhrase = 'online.citi.com';
    const mktPhrase = 'www.citi.com';

    if (url.indexOf(cbolPhrase) > -1) {
      return this._mktEnvironmentService.getEnvironmentVar('CBOL_URL') + url.substring(url.indexOf(cbolPhrase) + cbolPhrase.length);
    } else if (url.indexOf(mktPhrase) > -1) {
      return url.substring(url.indexOf(mktPhrase) + mktPhrase.length);
    } else {
      return url;
    }
  }
}
